import { 
  ClientPermissionsConfig, 
  IOrganizationConfigurationApiCall, 
  IRestApiService, 
  OrganizationConfiguration 
} from "../types";

class OrganizationConfigurationApiCall implements IOrganizationConfigurationApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  updateOrganizationConfiguration<T extends OrganizationConfiguration>(ownerId: string, configuration: T): Promise<T> {
    let url = `organization-configuration/owner/${ownerId}`;
    return this.restApiService.put(url, configuration);
  }

  getOrganizationConfigurationByName<T extends OrganizationConfiguration>(ownerId: string, name: string): Promise<T> {
    let url = `organization-configuration/owner/${ownerId}/by-name/${name}`;
    return this.restApiService.get(url);
  }

  getClientPermissionsConfiguration(ownerId: string): Promise<ClientPermissionsConfig> {
    const url = `organization-configuration/owner/${ownerId}/client-permissions`;
    return this.restApiService.get(url);
  }

  disconnectBinotel(ownerId: string): Promise<any> {
    return this.restApiService.delete(`organization-configuration/owner/${ownerId}/binotel`);
  }
}

export default OrganizationConfigurationApiCall;